import { combineReducers, compose, createStore as _createStore, applyMiddleware, CombinedState } from 'redux';
import thunk, { ThunkMiddleware } from 'redux-thunk';

import { IApplicationState, TReduxActions, IReduxStore, IThunkContext } from '../../types/redux';

import * as reducers from '../../reducers';

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param debugEnabled - режим разработки
 * @param context - контекст, передаваемый в thunk-экшны
 */
export function createReduxStore(
  initialState: Partial<IApplicationState>,
  debugEnabled: boolean,
  context: IThunkContext,
) {
  const rootReducer = combineReducers<IApplicationState, TReduxActions>(reducers);

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(
    applyMiddleware(
      thunk.withExtraArgument(context) as ThunkMiddleware<IApplicationState, TReduxActions, IThunkContext>,
    ),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) as any;

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IApplicationState, {}>(
      rootReducer,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(rootReducer);

    return storeReminder;
  }

  return createStore();
}
